import React, { Component, Fragment } from "react";
import { languageService } from "../../../Language/language.service";
import { ButtonActionsTable, StyledButtonActionsTable } from "../../Common/Buttons";
import ThisTable from "../../Common/ThisTable";
import UISectionHeader from "../../Common/UISectionHeader";
import CustomForm from "../../../libraries/form";
import _ from "lodash";
import { hosActivityTypeFormSchema } from "./schemas/hosActivityTypeFormSchema";
import { FixedAppLookupsContext } from "../../FixedAppLookupsProvider";
import permissionCheck from "../../../utils/permissionCheck";
import { dataFormatters } from "../../../utils/dataFormatters";
import { updateShortSchema } from "../../../libraries/form/schemaInterpreter";
import "./style.css";

class ActivitiesList extends Component {
  constructor(props) {
    super(props);
    this.hosActivityTypesTableSchema = [
      {
        Header: languageService("Description"),
        accessor: "description",
        id: "description",
        minWidth: 125,
      },
      {
        Header: languageService("Value"),
        accessor: "opt2.value",
        id: "Value",
        minWidth: 125,
      },
      {
        Header: languageService("Code"),
        accessor: "opt2.code",
        id: "code",
        minWidth: 75,
      },
      {
        Header: languageService("Group"),
        accessor: "opt2.group",
        id: "group",
        minWidth: 150,
      },
      {
        Header: "Associated (Service Types)",
        accessor: "associatedServiceNames",
        Header: languageService("Associated (Service Types)"),
        accessor: "opt2.serviceCodes",
        id: "serviceCodes",
        minWidth: 300,
        // Cell: (d) => {
        //   const codes = Array.isArray(d.value) ? d.value : [];
        //   const { hosServiceTypesWithAllDetails } = this.context;
        //   const serviceTypes = hosServiceTypesWithAllDetails.filter((type) => codes.includes(type.code)).map((type) => type.description);
        //   return dataFormatters.stringArrayFormatter(serviceTypes);
        // },
      },
    ];
    this.state = {
      openAddEditActivityTypeForm: false,
      compiledActivityTypeFormSchema: null,
      addEditActivityTypeData: {},
      addEditActivityTypeFormState: null,
      selectedActivity: null,
      confirmationDialog: null,
    };

    this.closeDialog = this.closeDialog.bind(this);
    this.openAddActivityTypeForm = this.openAddActivityTypeForm.bind(this);
    this.openEditDeleteActivityTypeForm = this.openEditDeleteActivityTypeForm.bind(this);
    this.addActivityType = this.addActivityType.bind(this);
    this.updateActivityType = this.updateActivityType.bind(this);
    this.confirmDeleteActivityType = this.confirmDeleteActivityType.bind(this);
    this.compileActivityTypeFormSchema = this.compileActivityTypeFormSchema.bind(this);
  }

  closeDialog() {
    this.setState({
      openAddEditActivityTypeForm: false,
      compiledActivityTypeFormSchema: null,
      addEditActivityTypeData: {},
      addEditActivityTypeFormState: null,
      selectedActivity: null,
    });
  }

  compileActivityTypeFormSchema() {
    const { getServiceTypesWithCodesMultiSelectOptions } = this.context;
    let types = getServiceTypesWithCodesMultiSelectOptions(true).filter((e) => e.val !== "hosServiceType-6");
    let formSchema = updateShortSchema(_.cloneDeep(hosActivityTypeFormSchema), {
      serviceCodes: {
        selectOptions: types,
      },
    });
    return formSchema;
  }
  openAddActivityTypeForm() {
    this.setState({
      openAddEditActivityTypeForm: true,
      compiledActivityTypeFormSchema: this.compileActivityTypeFormSchema(),
      addEditActivityTypeData: {},
      addEditActivityTypeFormState: "create",
    });
  }

  addActivityType(submission) {
    const { getServiceTypesWithCodesMultiSelectOptions } = this.context;
    let { fields } = submission;
    // add new activity to the server
    let types = getServiceTypesWithCodesMultiSelectOptions(true, "Off Duty");
    const { createLookup, hosActivitiesWithAllDetails } = this.context;
    const newActivityType = { listName: "hosActivityTypes", ..._.pick(fields, ["description"]) };
    newActivityType.opt2 = { ..._.pick(fields, ["code", "value", "group", "isOffDuty"]) };
    newActivityType.opt2.serviceCodes = newActivityType.opt2.isOffDuty ? [...types.map((item) => item.val)] : fields.serviceCodes;

    createLookup && createLookup(newActivityType, hosActivitiesWithAllDetails);

    this.setState({
      selectedActivity: null,
      addEditActivityTypeData: {},
      compiledActivityTypeFormSchema: null,
      openAddEditActivityTypeForm: false,
      addEditActivityTypeFormState: null,
    });
  }

  updateActivityType(submission) {
    let { fields } = submission;
    const { getServiceTypesWithCodesMultiSelectOptions } = this.context;
    const { selectedActivity } = this.state;
    const { updateLookup } = this.context;
    const updatedRecord = { ...selectedActivity, ..._.pick(fields, ["description"]) };
    updatedRecord.opt2 = { ...updatedRecord.opt2, ..._.pick(fields, ["code", "value", "group", "isOffDuty"]) };
    updatedRecord.opt2.serviceCodes = updatedRecord.opt2.isOffDuty
      ? [...getServiceTypesWithCodesMultiSelectOptions(true, "Off Duty").map((item) => item.val)]
      : fields.serviceCodes;

    updateLookup && updateLookup(updatedRecord);

    this.setState({
      selectedActivity: null,
      addEditActivityTypeData: {},
      compiledActivityTypeFormSchema: null,
      openAddEditActivityTypeForm: false,
      addEditActivityTypeFormState: null,
    });
  }

  openEditDeleteActivityTypeForm(originalRow, state) {
    this.setState({
      selectedActivity: originalRow,
      openAddEditActivityTypeForm: true,
      compiledActivityTypeFormSchema: this.compileActivityTypeFormSchema(),
      addEditActivityTypeData: {
        description: originalRow.description,
        value: originalRow.opt2.value,
        code: originalRow.opt2.code ? originalRow.opt2.code : "",
        group: originalRow.opt2.group,
        isOffDuty: originalRow.opt2.isOffDuty ? true : false,
        serviceCodes: originalRow.opt2.serviceCodes,
      },
      addEditActivityTypeFormState: state,
    });
  }

  confirmDeleteActivityType() {
    const { deleteLookup } = this.context;
    const { selectedActivity } = this.state;
    deleteLookup && deleteLookup(selectedActivity);

    this.setState({
      selectedActivity: null,
      openAddEditActivityTypeForm: false,
      compiledActivityTypeFormSchema: null,
      addEditActivityTypeData: {},
      addEditActivityTypeFormState: null,
    });
  }

  render() {
    // todo: renable following block
    const adminAccess = permissionCheck("USER", "update");
    // const adminAccess = false;
    const { openAddEditActivityTypeForm, addEditActivityTypeData, addEditActivityTypeFormState, compiledActivityTypeFormSchema } =
      this.state;
    const { hq } = this.props;
    const { hosActivitiesWithAllDetails, hosServiceTypesWithAllDetails } = this.context;
    const tableData = hosActivitiesWithAllDetails.map((activity) => {
      var codes = activity.opt2 && Array.isArray(activity.opt2.serviceCodes) ? activity.opt2.serviceCodes : [];

      var serviceNames = hosServiceTypesWithAllDetails
        .filter((type) => {
          return codes.indexOf(type.code) !== -1;
        })
        .map((type) => {
          return type.description;
        });

      return { ...activity, associatedServiceNames: serviceNames.join(", ") };
    });
    return (
      <div>
        <UISectionHeader
          title={languageService("Activity Types List")}
          addPermission={adminAccess}
          addButtonTitle={languageService("Add New Activity Type")}
          addCallback={this.openAddActivityTypeForm}
        />
        <ThisTable
          tableColumns={[
            ...this.hosActivityTypesTableSchema,
            {
              Header: languageService("Actions"),
              id: "actions",
              Cell: (d) => {
                return (
                  <div>
                    {adminAccess ? (
                      <Fragment>
                        <StyledButtonActionsTable title="Edit" onClick={() => this.openEditDeleteActivityTypeForm(d.original, "edit")} />
                        <StyledButtonActionsTable
                          title="Delete"
                          onClick={() => this.openEditDeleteActivityTypeForm(d.original, "delete")}
                        />
                      </Fragment>
                    ) : null}
                  </div>
                );
              },
              minWidth: 200,
            },
          ]}
          tableData={tableData}
          pagination={true}
          forDashboard={false}
          height={"auto"}
          onClickSelect
        />
        {openAddEditActivityTypeForm && (
          <CustomForm
            mode="dialog"
            currState={addEditActivityTypeFormState}
            fieldsData={addEditActivityTypeData}
            formSchema={compiledActivityTypeFormSchema}
            closeDialog={this.closeDialog}
            parentRef={{
              updateActivityType: this.updateActivityType,
              addActivityType: this.addActivityType,
              confirmDeleteActivityType: this.confirmDeleteActivityType,
            }}
          />
        )}
      </div>
    );
  }
}

ActivitiesList.contextType = FixedAppLookupsContext;

export default ActivitiesList;



// WEBPACK FOOTER //
// ./src/components/HoursOfService/ActivitiesList/index.jsx